import React, { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ShieldCheck, XCircle, Smartphone } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function VerifyLicense() {
  const { token } = useParams();
  const { refreshUser } = useAuth();
  const [state, setState] = useState("working"); // working | ok | error | auth
  const [msg, setMsg] = useState("");
  const [lic, setLic] = useState(null);
  const firedRef = useRef(false);

  useEffect(() => {
    if (firedRef.current) return;
    firedRef.current = true;
    api.post(`/license/verify/${token}`)
      .then((r) => { setLic(r.data); setState("ok"); refreshUser(); })
      .catch((e) => {
        if (e.response?.status === 401) { setState("auth"); }
        else { setMsg(apiError(e.response?.data?.detail) || "Verification failed."); setState("error"); }
      });
  }, [token]);

  return (
    <div className="max-w-md mx-auto animate-slide-up text-center py-8" data-testid="verify-license-page">
      {state === "working" && <p className="text-race-sub">Verifying…</p>}

      {state === "ok" && (
        <div data-testid="verify-success">
          <ShieldCheck className="mx-auto text-race-volt mb-3" size={48} />
          <h1 className="font-heading text-5xl tracking-tight mb-2">LICENSE ACTIVATED</h1>
          <p className="text-race-sub text-sm mb-6 flex items-center justify-center gap-1"><Smartphone size={14} /> Bound to this phone.</p>
          <div className="bg-race-elevated border border-race-line p-6 text-left">
            <div className="overline text-race-red">IBRA · Text Racing</div>
            <div className="font-heading text-3xl tracking-tight">{lic?.holder_name}</div>
            <div className="font-mono text-sm text-race-sub mt-2">{lic?.license_no}</div>
          </div>
          <Link to="/dashboard" data-testid="verify-continue"
            className="mt-6 inline-block bg-race-red hover:bg-race-redhover text-race-bg font-heading text-2xl tracking-wide px-8 py-3 rounded-sm transition-colors">
            Enter Pit Lane
          </Link>
        </div>
      )}

      {state === "auth" && (
        <div data-testid="verify-auth">
          <p className="text-race-sub mb-4">Sign in on this phone with the account that applied, then reopen the link to finish verifying.</p>
          <Link to="/login" className="inline-block bg-race-red hover:bg-race-redhover text-race-bg font-heading text-xl tracking-wide px-6 py-2 rounded-sm">Sign In</Link>
        </div>
      )}

      {state === "error" && (
        <div data-testid="verify-error">
          <XCircle className="mx-auto text-race-red mb-3" size={48} />
          <h1 className="font-heading text-4xl tracking-tight mb-2">LINK PROBLEM</h1>
          <p className="text-race-sub text-sm mb-6">{msg}</p>
          <Link to="/license" className="inline-block border border-race-line hover:border-race-txt text-race-txt px-6 py-2 rounded-sm">Request a new link</Link>
        </div>
      )}
    </div>
  );
}
